import * as React from 'react';
import {
	Datagrid,
	DateField,
	ImageField,
	ListProps,
	NumberField,
	ReferenceField,
	TextField,
	UrlField
} from 'react-admin';
import './MarathonDatagrid.scss';

export const MarathonDatagrid = (props: ListProps): React.ReactElement => {
	return (
		<Datagrid rowClick="show" className="marathons-table" optimized
		          hasBulkActions={true}
		          rowStyle={(row: any) => ({ borderRightColor: row._readAt ? '#49d18c' : '#bbbbbb' })}>
			<TextField source="id" label="#"/>
			<ImageField source="featuredImageUrl" label="FEATURED_IMAGE_URL"/>
			<TextField source="name" label="NAME"/>
			<TextField source="agenda" label="AGENDA"/>
			<NumberField source="duration" label="DURATION"/>
			<DateField source="date" label="DATE"/>
			<UrlField source="groupLink" label="GROUP_LINK"/>
			<ReferenceField source="coachId" reference="clients" label="COACH">
				<TextField source="fullName"/>
			</ReferenceField>
			<NumberField source="participantsIds.length" label="NUMBER_OF_PARTICIPANTS"/>
		</Datagrid>
	);
};
